import React from "react";
import { Plus, Trash2, Edit } from "lucide-react";

interface SchoolItemProps {
  school: {
    id: string;
    name: string;
    user_id: string;
    created_at: string;
    district_id: string;
  };
  creatorName: string;
  districtName: string;
  teachersCount: number;
  onAddTeacher: (school: any) => void;
  onEdit: (school: {
    id: string;
    name: string;
    user_id: string;
    created_at: string;
    district_id: string;
  }) => void;
  onDelete: (school: {
    id: string;
    name: string;
    user_id: string;
    created_at: string;
    district_id: string;
  }) => void;
}

export function SchoolItem({
  school,
  creatorName,
  districtName,
  teachersCount,
  onAddTeacher,
  onEdit,
  onDelete,
}: SchoolItemProps) {
  return (
    <tr key={school.id}>
      <td className="px-6 py-4">
        <div className="text-sm font-medium text-gray-900">{school.name}</div>
      </td>
      <td className="px-6 py-4">
        <div className="text-sm text-gray-500">{districtName}</div>
      </td>
      <td className="px-6 py-4">
        <div className="text-sm text-gray-500">{creatorName}</div>
      </td>
      <td className="px-6 py-4">
        <div className="text-sm text-gray-500">
          {new Date(school.created_at).toLocaleDateString()}
        </div>
      </td>
      <td className="px-6 py-4">
        <div className="flex items-center space-x-2">
          <span className="text-sm text-gray-900">{teachersCount}</span>
          <button
            onClick={() => onAddTeacher(school)}
            className="text-gray-400 hover:text-gray-600 transition-colors"
            title="Add Teacher"
          >
            <Plus className="h-4 w-4" />
          </button>
        </div>
      </td>
      <td className="px-6 py-4">
        <div className="flex items-center space-x-2">
          <button
            onClick={() => onEdit(school)}
            className="text-blue-400 hover:text-blue-600 transition-colors"
            title="Edit School"
          >
            <Edit className="h-5 w-5" />
          </button>
          <button
            onClick={() => onDelete(school)}
            className="text-red-400 hover:text-red-600 transition-colors"
            title="Delete School"
          >
            <Trash2 className="h-5 w-5" />
          </button>
        </div>
      </td>
    </tr>
  );
}
